import styled, { keyframes } from "styled-components";
import {ThemeType} from "../../types/Theme";

export const ComponenteCarregandoPagina = styled.div<{theme: ThemeType, relative: boolean}>`
  position: ${(props) => (props.relative ? "static" : "fixed")};
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.modal};
  z-index: 200;
`;
